import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function TeacherAssignments() {
  const { t } = useTranslation();
  const [classes, setClasses] = useState([]);
  const [selected, setSelected] = useState("");
  const [asgs, setAsgs] = useState([]);
  const [form, setForm] = useState({ title: "", subject: "math", grade_level: "3", description: "", questions: [{ q: "" }] });

  async function load() { const r = await api.get("/teacher/classes"); setClasses(r.data); if (r.data[0]) setSelected(r.data[0].id); }
  useEffect(() => { load(); }, []);
  useEffect(() => { if (!selected) return; api.get(`/teacher/assignments/${selected}`).then((r) => setAsgs(r.data)); }, [selected]);

  async function create(e) {
    e.preventDefault();
    try {
      await api.post("/teacher/assignments", { class_id: selected, ...form, questions: form.questions.filter((q) => q.q) });
      setForm({ title: "", subject: "math", grade_level: "3", description: "", questions: [{ q: "" }] });
      const r = await api.get(`/teacher/assignments/${selected}`); setAsgs(r.data);
      toast.success(t("assignments.submitOk"));
    } catch { toast.error(t("errors.generic")); }
  }

  return (
    <AppShell>
      <h1 className="font-adult font-bold text-3xl text-slate-900">{t("teacher.assignmentsTab")}</h1>
      <p className="text-slate-600">{t("teacher.assignmentsBody")}</p>

      <div className="mt-4">
        <Label>{t("teacher.class")}</Label>
        <select className="w-full sm:w-72 mt-1 border border-slate-300 rounded-md p-2 text-sm" value={selected} onChange={(e) => setSelected(e.target.value)} data-testid="asg-class-select">
          {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>

      <form onSubmit={create} className="hb-card p-5 mt-5 grid sm:grid-cols-2 gap-3">
        <div><Label>{t("teacher.titleField")}</Label><Input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="asg-title" /></div>
        <div><Label>{t("teacher.subject")}</Label><Input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} /></div>
        <div><Label>{t("teacher.grade")}</Label><Input required value={form.grade_level} onChange={(e) => setForm({ ...form, grade_level: e.target.value })} /></div>
        <div className="sm:col-span-2"><Label>{t("teacher.description")}</Label><Textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="asg-desc" /></div>
        <div className="sm:col-span-2">
          <Label>{t("teacher.questions")}</Label>
          {form.questions.map((q, i) => (
            <Input key={`q-${i}`} className="mt-2" placeholder={`${t("teacher.questions")} ${i + 1}`} value={q.q} onChange={(e) => {
              const nq = [...form.questions]; nq[i] = { q: e.target.value }; setForm({ ...form, questions: nq });
            }} data-testid={`asg-q-${i}`} />
          ))}
          <div className="mt-2 flex gap-2">
            <Button type="button" size="sm" variant="outline" onClick={() => setForm({ ...form, questions: [...form.questions, { q: "" }] })}>{t("teacher.addQuestion")}</Button>
          </div>
        </div>
        <div className="sm:col-span-2 text-right">
          <Button type="submit" className="rounded-full bg-slate-900 text-white hover:bg-slate-800" data-testid="asg-create">{t("teacher.createAssignment")}</Button>
        </div>
      </form>

      <div className="mt-6 space-y-3">
        {asgs.map((a) => (
          <div key={a.id} className="hb-card p-4 flex justify-between items-center" data-testid={`t-asg-${a.id}`}>
            <div>
              <div className="font-semibold text-slate-900">{a.title}</div>
              <div className="text-xs text-slate-500">{a.subject} · {t("student.grade")} {a.grade_level} · {a.submission_count} {t("teacher.submissions")}</div>
            </div>
          </div>
        ))}
      </div>
    </AppShell>
  );
}
